// --- Actions & Hooks
import {
  fetchUserPermissions,
  logout,
  setAuthToken,
  setAuthUser,
  setSessionStart,
} from "./actions";
// --- External Libraries
// --- Utilities
import { getCurrentUser, getToken } from "../../utils/localStorageService";
// --- Config

/**
 * Action to set the session start time.
 *
 * This action is dispatched to set the session start time in the Redux store.
 * It takes a payload containing the session start time.
 *
 * @returns {(function(*): Promise<void>)|*}
 */
const initialize = () => async (dispatch) => {
  await dispatch(setAuthToken(getToken()));
  await dispatch(setAuthUser(getCurrentUser()));
};

export {
  fetchUserPermissions,
  logout,
  setAuthToken,
  setAuthUser,
  initialize,
  setSessionStart,
};
